import { lazy } from "react";
import { Navigate } from "react-router-dom";

const SQLAuditOverview_V2 = lazy(
  () => import("pages/Security/Events_V2/MonitoringSQLAuditOverview")
);
const Audit_V2 = lazy(() => import("pages/Security/Events_V2/MonitoringSQLAuditReport"));
const SecurityOverviewPage = lazy(
  () => import("pages/Security/SecurityAccounts/Overview/SecurityOverview")
);
const SecurityDetailsPage = lazy(
  () => import("pages/Security/SecurityAccounts/Detail/SecurityDetails")
);

export const security = [
  {
    path: "security",
    element: <Navigate to="event_overview" replace />,
  },
  {
    path: "security",
    children: [
      {
        path: "event_overview",
        element: <SQLAuditOverview_V2 />,
      },
      {
        path: "event_details",
        element: <Audit_V2 />,
      },
      {
        path: "security_overview",
        element: <SecurityOverviewPage />,
      },
      {
        path: "security_details",
        element: <SecurityDetailsPage />,
      },
    ],
  },
];
